/**
 * Thème de l'espace élève — source unique des couleurs/dégradés gamifiés.
 * Les vues élève importaient jusqu'ici ces valeurs en dur (inline styles) ;
 * on centralise SANS toucher tailwind.config (figé). Adoption au point de
 * contact : seuls les fichiers retravaillés importent ce module.
 */

export const ELEVE_COLORS = {
    navy: '#0A1F3D',
    navy2: '#122E54',
    cyan: '#29B6E8',
    blue: '#2D7FF9',
    marine: '#1E3A8A',
    orange: '#F97316',
    gold: '#FFB938',
    vert: '#1F9D55',
    rouge: '#E0483D',
    gris: '#9FB6CC',
};

export const ELEVE_GRADIENTS = {
    fond: 'linear-gradient(180deg, #0A1F3D 0%, #122E54 62%, #0A1F3D 100%)',
    cta: 'linear-gradient(120deg, #F97316, #FFB938)',
    xpBar: 'linear-gradient(90deg, #29B6E8, #FFB938)',
    progress: 'linear-gradient(90deg, #F59E0B, #F97316)',
    niveau: 'linear-gradient(135deg, #29B6E8, #1E3A8A)',
    orTitre: 'linear-gradient(180deg, #FFD740, #E8A000)',
};

/** Halos décoratifs du fond navy (recette de la passation, réutilisable). */
export const ELEVE_HALOS = [
    { style: { position: 'absolute', top: '-80px', left: '-90px', width: '340px', height: '340px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(41,182,232,.16), transparent 70%)', filter: 'blur(6px)', pointerEvents: 'none' } },
    { style: { position: 'absolute', bottom: '-100px', right: '-70px', width: '380px', height: '380px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(249,115,22,.13), transparent 70%)', filter: 'blur(8px)', pointerEvents: 'none' } },
];
